import React, {useCallback, useEffect, useRef} from 'react';
import Webcam from 'react-webcam';
import {useDispatch} from 'react-redux';
import StudioControlComponent from './StudioControlComponent';
import StudioResizeListener from './StudioResizeListener';
import ViewSwitcher from './ViewSwitcher';
import {setOpenStudio} from '../../store/modules/studio/actions';
import { StudioComponentStyles, StudioControlStyles } from './styles';
import useId from '../../hooks/useId';
import AudioServiceInitializer from './AudioServiceInitializer';
import {useHistory, useRouteMatch} from "react-router";
import {clipLastSegmentRoute} from "../../utility/path";

const StudioComponent = () => {
  const classes = StudioComponentStyles();
  const controlClasses = StudioControlStyles();
  const dispatch = useDispatch();
  const { url } = useRouteMatch();

  const mainViewContainerId = useId();
  const bottomViewContainerId = useId();

  const refControlStudioContainer = useRef<HTMLDivElement>(null);
  const webcamRef = useRef<Webcam & HTMLVideoElement | null>(null);
  const refPrompter = useRef<HTMLDivElement>(null);
  const { push } = useHistory();

  const closeStudio = useCallback(() => {
    dispatch(setOpenStudio(false));
    window.studioAudioService?.close();
    push(clipLastSegmentRoute(url));
  }, [dispatch, url, push]);

  useEffect(() => {
    const keyDownHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeStudio();
      }
    };

    window.addEventListener('keydown', keyDownHandler);
    return () => {
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, [closeStudio]);

  return (
    <>
      <div className={classes.root}>
        <ViewSwitcher
          refPrompter={refPrompter}
          webcamRef={webcamRef}
          mainViewContainerId={mainViewContainerId}
          bottomViewContainerId={bottomViewContainerId}
        />
        <div id={mainViewContainerId} />
        <div ref={refControlStudioContainer} className={controlClasses.studioControlWrapper}>
          <StudioControlComponent
            refPrompter={refPrompter}
            bottomViewContainerId={bottomViewContainerId}
          />
        </div>
        <StudioResizeListener
          mainViewContainerId={mainViewContainerId}
          refControlStudioContainer={refControlStudioContainer}
        />
      </div>
      <AudioServiceInitializer />
    </>
  );
};

export default StudioComponent;
